import { authApi } from "@api";
import { ComponentBread, ComponentHeader, StyledCreate } from "@components";
import { IAdmin } from "@interfaces";
import { AdminForm } from "@modules";
import { setLoading } from "@redux";
import { useNotify } from "@utils";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";

const data = [
  {
    title: <a href={"/admins"}>Admins</a>,
  },
  {
    title: <a href={"/add-admin"}>Add Admin</a>,
  },
];
export const PageCreateAdmin = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const { error } = useNotify();
  const { t } = useTranslation();
  const [admin, setAdmin] = useState<IAdmin>();
  useEffect(() => {
    if (id) {
      fetchAdmin();
    }
  }, [id]);

  const fetchAdmin = async () => {
    try {
      dispatch(setLoading(true));
      const res = await authApi.detail(id);
      setAdmin(res.data);
    } catch (err: any) {
      error(t("message.create.fail"));
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <>
      <ComponentHeader title={t("page.admin_user")} />
      <StyledCreate>
        <ComponentBread pages={data} />
        <AdminForm admin={admin} />
      </StyledCreate>
    </>
  );
};
